import { Component, Input } from '@angular/core';
import { DevelopmentCenterWistiaAsset } from '../../models/development-center.models';

@Component({
  selector: 'app-development-center-wistia-media',
  templateUrl: './development-center-wistia-media.component.html',
})
export class DevelopmentCenterWistiaMediaComponent {
  @Input() model?: DevelopmentCenterWistiaAsset;
}